import React, { Component } from "react";
import styles from "./MedalsStorage.module.css";

class MedalSection extends Component {
  render() {
    return (
      <div className={styles.medalWithDescription}>
        <div className={styles.medalImgWrapper}>
          <img
            className={[
              styles.medal,
              this.props.disabled && styles.lockMedal,
            ].join(" ")}
            src={this.props.src}
            alt={this.props.description}></img>
        </div>
        <p>{this.props.description}</p>
      </div>
    );
  }
}

export default MedalSection;
